import { useSearchModels } from '#pplx/frontend/ask-models/hooks/useSearchModels.js';
import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { useMemo } from 'react';
/**
 * Returns the default search model based on the dynamic model config.
 * @deprecated use @useSearchModels directly
 */
export const useDefaultSearchModel = () => {
    const { getDefaultModelForMode } = useSearchModels({
        reason: 'use_default_search_model',
    });
    return useMemo(() => getDefaultModelForMode(SearchMode.SEARCH), [getDefaultModelForMode]);
};
//# sourceMappingURL=useDefaultSearchModel.js.map